/**
 * 个股顶部盘口-异常交易状态
 */
import React from "react"
import { StockErrorTradeStatus } from "../pagetype"
import { quote_chart, quote_item_name, single_quote } from "../quotedata/index"

export function StockHeaderErrorTradeStatus(props: { store: any; trade_status: StockErrorTradeStatus }) {
  return (
    <div>
      {props.trade_status != StockErrorTradeStatus.未知 ? (
        <>
          <p className="stock-value">{props.store.chart_mouse_move_data ? quote_chart[quote_item_name.最新价](props.store.chart_mouse_move_data.newPrice, props.store.chart_mouse_move_data.zde).element : single_quote[quote_item_name.最后价格](props.store.StockDetail)}</p>
          <p>
            {props.store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌幅](props.store.chart_mouse_move_data.zdf, props.store.chart_mouse_move_data.zde).scale_element : <span className="stop-trade">{StockErrorTradeStatus[props.trade_status]}</span>}
            {props.store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌额](props.store.chart_mouse_move_data.zde).element : <span></span>}
          </p>
        </>
      ) : (
        <>
          <p className="stock-value">{props.store.chart_mouse_move_data ? quote_chart[quote_item_name.最新价](props.store.chart_mouse_move_data.newPrice, props.store.chart_mouse_move_data.zde).element : single_quote[quote_item_name.最新价](props.store.StockDetail).element}</p>
          <p>
            {props.store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌幅](props.store.chart_mouse_move_data.zdf, props.store.chart_mouse_move_data.zde).scale_element : single_quote[quote_item_name.涨跌幅](props.store.StockDetail).scale_element}
            {props.store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌额](props.store.chart_mouse_move_data.zde).element : single_quote[quote_item_name.涨跌额](props.store.StockDetail).element}
          </p>
        </>
      )}
    </div>
  )
}
